import React from 'react';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';
import { ESignAgreementField } from './components/ESignAgreementField';
import { TextMessageConsentField } from './components/TextMessageConsentField';

export const ESignPanel: React.FC = () => {
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);

    if (!isBroker) return null;

    return (
        <div className='e-sign-container'>
            <div className='agreement-section'>
                <ESignAgreementField />
            </div>
            <div className='text-message-section'>
                <TextMessageConsentField />
            </div>
        </div>
    );
};
